module.exports = __webpack_public_path__ + "img/tbt312-2-1993.prt.dba41783.jpg";